<template>
            <textarea
                ref="autoHeightTextarea"
                v-model="currentNote"
                @blur="saveNote"
                :style="{ height: `${height}px` }"
                @input="adjustHeight"
                class="form-control border-0"
                placeholder="Write your note here..." rows="4"></textarea>
</template>

<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';

export default {
    props: {
        currentQuestion: Object,
        title: {
            type: Object,
            required: true,
            default: "Note"
        }
    },
    data() {
        return {
            initNote: '',
            currentNote: '',
            height: 150
        };
    },
    watch: {
        currentQuestion: {
            handler(newQuestion) {
                if (newQuestion && newQuestion.note && newQuestion.note?.text) {
                    this.currentNote = newQuestion.note?.text;
                } else {
                    this.currentNote = '';  // Reset if no note
                }
            },
            deep: true
        }
    },
    created() {
        this.currentNote = this.currentQuestion?.note?.text;
        this.initNote = this.currentQuestion?.note?.text;
    },
    methods: {
        adjustHeight() {
            const textarea = this.$refs.autoHeightTextarea;
            textarea.style.height = 'auto';  // Reset height to recalculate
            this.height = textarea.scrollHeight;  // Set the height to scroll height
        },
        saveNote() {
            if(this.initNote === this.currentNote) return null;

            const toast = useToast();
            const id = toast.info('Saving note...', { icon: 'fa-solid fa-download' });

            const noteData = {
                question_id: this.currentQuestion.id,
                text: this.currentNote,
                'subscribe_id': this.$route.params?.subscribe_id
            };

            axios.post('notes', noteData)
                .then(response => {
                    toast.dismiss(id);
                    toast.success(response.data.message, { timeout: 1000, icon: 'fa-solid fa-circle-check' });
                })
                .catch(error => {
                    toast.dismiss(id);
                    if (error.response) {
                        toast.error(error.response.data.message, { timeout: 3000, icon: 'fa-solid fa-circle-exclamation' });
                    }
                });
        }
    }
};
</script>

<style scoped>
textarea {
    resize: none;
}
</style>
